module.exports = __webpack_public_path__ + "img/0CC39C3DE7A303822618DA6CDB4F6126.0cc39c3d.png";